var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image-carousel vuetified container-fluid mb-5" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "position-relative", class: _vm.gridClasses },
          [
            _c(
              "div",
              { staticClass: "position-relative" },
              [
                _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
                  _c("img", {
                    key: _vm.image,
                    staticClass: "w-100 h-auto",
                    attrs: { src: _vm.image }
                  })
                ]),
                _vm._v(" "),
                _vm.hasStamp
                  ? _c("stamp", {
                      staticClass: "stamp--overlay",
                      class: _vm.stampClasses
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "position-absolute align-items-center image-carousel__actions"
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn__round spot-background spot-front-text",
                    on: {
                      click: function($event) {
                        return _vm.next(+1)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "icon-right-arrow",
                      staticStyle: { transform: "translate(1px, -2px)" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn__round spot-background spot-front-text",
                    on: {
                      click: function($event) {
                        return _vm.next(-1)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "icon-left-arrow",
                      staticStyle: { transform: "translate(-3px, -1px)" }
                    })
                  ]
                )
              ]
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }